// Traderz Life — minimal theme JS
document.addEventListener('change', function (e) {
  var f = e.target.closest('[data-cart-qty]');
  if (f) { f.closest('form').submit(); }
});

// Product gallery: click a thumbnail to show it in the main window
function tlShowImage(btn) {
  if (!btn) return;
  var main = document.querySelector('[data-main-img]');
  if (main) {
    main.src = btn.dataset.src;
    if (btn.dataset.alt) main.alt = btn.dataset.alt;
  }
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.classList.toggle('is-active', t === btn);
  });
}
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-thumb]');
  if (btn) { e.preventDefault(); tlShowImage(btn); }
});

// Variant select: update id, price and switch to the variant's image
document.addEventListener('change', function (e) {
  if (!e.target.matches('[data-variant-select]')) return;
  var form = e.target.closest('form');
  if (!form) return;
  var id = e.target.value;
  var hidden = form.querySelector('[name="id"]');
  if (hidden) hidden.value = id;
  var priceEl = document.querySelector('[data-variant-price]');
  var opt = e.target.selectedOptions[0];
  if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
  if (opt && opt.dataset.imageId) {
    tlShowImage(document.querySelector('[data-thumb][data-id="' + opt.dataset.imageId + '"]'));
  }
});
